export default __webpack_public_path__ + "static/media/eye.f78f345e.svg";